<script setup lang="ts">
import { useToast } from '@/composables/useToast'
import i18n from '@/i18n'

/* The global composer: shared primitives must render without the plugin. */
const { t: tr } = i18n.global

const { toasts, dismiss } = useToast()

const ICONS = {
  success: 'fa-solid fa-circle-check',
  info: 'fa-solid fa-circle-info',
  warn: 'fa-solid fa-triangle-exclamation',
  error: 'fa-solid fa-circle-xmark',
  ai: 'fa-solid fa-wand-magic-sparkles',
}

function onAction(t) {
  try {
    t.onAction?.()
  } catch (_) {
    /* noop */
  }
  dismiss(t.id)
}
</script>

<template>
  <div
    id="lx-toast-stack"
    class="toast-stack"
    role="region"
    :aria-label="tr('ui.toast.region')"
    aria-live="polite"
  >
    <div
      v-for="t in toasts"
      :key="t.id"
      class="toast is-visible"
      :class="`toast--${t.type}`"
      role="status"
    >
      <span class="toast__icon"><i :class="ICONS[t.type] || ICONS.success"></i></span>
      <div class="toast__body">
        <span class="toast__title">{{ t.title }}</span>
        <span v-if="t.sub" class="toast__sub">{{ t.sub }}</span>
        <a v-if="t.actionLabel" class="toast__action" href="#" @click.prevent="onAction(t)">
          {{ t.actionLabel }}
        </a>
      </div>
      <button
        class="toast__close"
        type="button"
        :aria-label="tr('common.close')"
        @click="dismiss(t.id)"
      >
        <i class="fa-solid fa-xmark"></i>
      </button>
    </div>
  </div>
</template>
